import React, { useState } from "react";
import ham from "../../assets/mobile-ham.svg";
import logo from "../../assets/loggo.svg";
import notifications from "../../assets/notifications.svg";
import profile from "../../assets/profile-photo.svg";
import logo2 from "../../assets/logo-black.svg";
import home from "../../assets/home.svg";
import wallet from "../../assets/wallet.svg";
import trade from "../../assets/trade.svg";
import transaction from "../../assets/transaction.svg";
import logout from "../../assets/logout.svg";
import contact from "../../assets/contact.svg";
import drag from "../../assets/drag.svg";
import { useNavigate, useLocation } from "react-router-dom";

function MobileNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen((prevState) => !prevState);
    console.log("opened");
  };

  const navItems = [
    {
      name: "Home",
      icon: home,
      path: "/dashboard",
    },
    {
      name: "Wallet",
      icon: wallet,
      path: "/wallet",
    },
    {
      name: "Trade assets",
      icon: trade,
      path: "/trading",
    },
    {
      name: "Transaction",
      icon: transaction,
      path: "/transactionhistory",
    },
    {
      name: "Contact us",
      icon: contact,
      path: "/contact",
    },
    {
      name: "Log out",
      icon: logout,
      path: "/logout",
    },
  ];

  return (
    <div className="px-[40px] pt-[31px] flex items-center justify-between pb-[43px] w-screen relative z-10 ">
      <button onClick={handleOpen}>
        {" "}
        <img src={ham} alt="" />
      </button>
      <img src={logo} alt="" />
      <div className="flex items-center gap-[10px] ">
        <img src={notifications} alt="" className="w-[12px] h-[14px] " />
        <img src={profile} alt="" className="rounded-full" />
      </div>
      {open && (
        <div className="h-full">
          <div
            className="absolute left-0 top-0 w-full z-30 bg-[#B0AFAF]/80 h-screen"
            onClick={handleOpen}
          ></div>
          <div className="absolute left-0 top-0 z-50 bg-white h-screen flex flex-col w-[50%] gap-[50px] pt-[50px] pl-[10px] ">
            <img src={logo2} alt="" className="w-[71px] h-[28px] pl-[18px] " />
            <button onClick={handleOpen} className="self-end mr-[-15px] ">
              <img src={drag} alt="" />
            </button>
            <nav className="">
              {navItems.map((item) => (
                <button
                  className={`flex items-center hover:border-l-[#FBC108] hover:border-l-[11px]  pl-[18px] hover:bg-[#ffffff70] py-[13px] md:w-[230px] ${
                    location.pathname === item.path
                      ? "bg-gradient-to-r from-[#FBC108]/20 to-white border-l-[11px] border-l-[#FBC108]"
                      : ""
                  }   `}
                  onClick={() => navigate(item.path)}
                >
                  <img src={item.icon} alt="" className="" />
                  <h6 className="md:text-xl text-xs">{item.name}</h6>
                </button>
              ))}
            </nav>
          </div>
        </div>
      )}
    </div>
  );
}

export default MobileNav;
